import { Modal, Button } from "@renderbus/ui";
import styled from "styled-components";
import { useEffect, useState } from "react";
import StompSocket from "@/components/websocket/stomp-socket";
import Cookie from "project-config/utils/cookie";
import PaySuccessIcon from "@/assets/icons/topup/paysuccess";
import {
  PAY_SUCCESS_SOCKET,
  PAY_HAS_SCANNED_SOCKET,
} from "@/components/websocket/constant";
import { useGlobalStore } from "@/store/GlobalStore";
import { isDev } from "project-config/utils/env";
import { Trans, useTranslation } from "react-i18next";
import request from "project-config/services/request/request";
import { useFetchActivityInfoList } from "../../hooks/useFetchActivityInfoList";
import { usePictureTopUpStore } from "../../store";
import routerUtil from "@/utils/routerUtil";

interface StompClientProps {
  body: string;
}

export function PaySuccessSocket() {
  const { t } = useTranslation("center");
  const { userInfo } = useGlobalStore();
  const { activityInfoListRefetch } = useFetchActivityInfoList();
  const [stompClient, setStompClient] = useState<StompSocket>();
  const [openSuccessTip, setOpenSuccessTip] = useState(false);
  const { fetchUserData } = useGlobalStore();
  const { setter } = usePictureTopUpStore();

  const acknowledge = (
    userId: string | number,
    stompTempClient: StompSocket
  ) => {
    // @ts-ignore
    if (stompTempClient.stompClient.readyState !== 1) return;
    stompTempClient.send(`/rendering/message/greeting.${userId}`);
  };
  const subscribe = (stompTempClient: StompSocket) => {
    stompTempClient.subscribe(
      "/user/topic/msg",
      (frameObject: StompClientProps) => {
        if (frameObject.body) {
          switch (JSON.parse(frameObject.body).business) {
            case PAY_SUCCESS_SOCKET:
              // setOpenSuccessTip(true);
              break;
            case PAY_HAS_SCANNED_SOCKET:
              setter({
                hasScanned: true,
              });
              break;
            default:
              break;
          }
        }
      }
    );
  };

  const connectSocket = (userId: string | number) => {
    if (stompClient && stompClient.stompClient.connected && !userId) return;
    const userKey = Cookie.getCookie("rayvision_userKey");
    const stompTempClient = new StompSocket(
      `wss://${
        isDev() ? "task-pre" : "task"
      }.renderbus.com/websocket?userKey=${userKey}`
    );
    setStompClient(stompTempClient);
    stompTempClient.connect(
      {
        userKey: userKey,
      },
      () => {
        acknowledge(userId, stompTempClient);
      },
      () => {
        subscribe(stompTempClient);
      }
    );
  };

  const closePaySuccessDialog = () => {
    setOpenSuccessTip(false);
    fetchUserData();
    activityInfoListRefetch();
    window.location.reload();
  };

  const fetchRechargeMessage = async () => {
    const { code, data } = await request.get(
      "/api/rendering/user/getRechargeMessage"
    );
    if (code === 200 && data) {
      setOpenSuccessTip(true);
    }
  };

  useEffect(() => {
    if (!userInfo || stompClient) return;
    connectSocket(userInfo.userId || "");
    return () => {
      if (!stompClient) return;
      (stompClient as StompSocket).unSubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  useEffect(() => {
    const intervalId = setInterval(fetchRechargeMessage, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Modal
      width={600}
      closable={false}
      open={openSuccessTip}
      children={
        <PaySuccessContainer>
          <PaySuccessIcon />
          <p className="success-title">
            {t("header_payment_recharge_success")}
          </p>
          <p className="success-tip">
            <Trans
              i18nKey="header_payment_recharge_picture_tip"
              t={t}
              components={{
                span: (
                  <span
                    className="green"
                    onClick={() => routerUtil.navigate?.("/inviteRewards")}
                  />
                ),
              }}
            />
          </p>
          <Button onClick={() => closePaySuccessDialog()}>
            {t("edit_contact_confirm")}
          </Button>
        </PaySuccessContainer>
      }
      onCancel={() => closePaySuccessDialog()}
      footer={null}
    />
  );
}

const PaySuccessContainer = styled.div`
  margin: 42px auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 60px;
  text-align: justify;
  svg,
  button {
    margin: auto;
  }
  .success-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #edf2f5;
  }
  .success-tip {
    font-size: 14px;
    line-height: 24px;
    .green {
      color: var(--main-color);
      text-decoration: underline;
      cursor: pointer;
    }
  }
  button {
    width: 136px;
    height: 40px;
    background: #5c5d5f;
    border-radius: 4px;
    color: #ffffff;
    margin-top: 38px;
  }
`;
